export interface CarrierDisplayData {
  carrierId: string;
  scacName: string;
  scac: string;
}
